import { Link } from "react-router-dom";
import { useAppDispatch } from '../../store/Hooks';
import { clearStudentState } from "../../store/StudentSlice";
import { clearTeacherState } from "../../store/TeacherSlice";
import { setAxiosAuthToken } from "../../utils/AuthServices";


function Logout() {
    const dispatch = useAppDispatch()

    const handleLogout = () => {
        dispatch(clearStudentState())
        dispatch(clearTeacherState())
        localStorage.clear()
        setAxiosAuthToken("")
    }

    return (
        <div>
            <Link to="/loggedout" onClick={handleLogout} className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500">Kirjaudu ulos</Link>
        </div>
    )
}


export default Logout